export default __webpack_public_path__ + "static/media/4C7D2E79-CA58-4B22-AF68-82490DAA38FE_1_102_o.2f21936c.jpeg";